// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/feature_usage.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/feature_usage.proto.
 */
export const file_v1_feature_usage: GenFile = /*@__PURE__*/
  fileDesc("ChZ2MS9mZWF0dXJlX3VzYWdlLnByb3RvEgJ2MSJkCgxGZWF0dXJlVXNhZ2USDwoHZmVhdHVyZRgBIAEoCRINCgVldmVudBgCIAEoCRIlCgp1c2FnZV9kYXRlGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRINCgVjb3VudBgEIAEoBSI9ChlSZWNvcmRGZWF0dXJlVXNhZ2VSZXF1ZXN0EiAKBnVzYWdlcxgBIAMoCzIQLnYxLkZlYXR1cmVVc2FnZSIuChpSZWNvcmRGZWF0dXJlVXNhZ2VSZXNwb25zZRIQCghhY2NlcHRlZBgBIAEoBTKPAQoTRmVhdHVyZVVzYWdlU2VydmljZRJ4ChJSZWNvcmRGZWF0dXJlVXNhZ2USHS52MS5SZWNvcmRGZWF0dXJlVXNhZ2VSZXF1ZXN0Gh4udjEuUmVjb3JkRmVhdHVyZVVzYWdlUmVzcG9uc2UiI4LT5JMCHToBKiIYL3YxL2ZlYXR1cmUtdXNhZ2UvcmVjb3JkQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_api_annotations, file_google_type_date]);

/**
 * FeatureUsage is how many times one event happened on one Vietnam date.
 *
 * @generated from message v1.FeatureUsage
 */
export type FeatureUsage = Message<"v1.FeatureUsage"> & {
  /**
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * @generated from field: string event = 2;
   */
  event: string;

  /**
   * @generated from field: google.type.Date usage_date = 3;
   */
  usageDate?: Date;

  /**
   * @generated from field: int32 count = 4;
   */
  count: number;
};

/**
 * Describes the message v1.FeatureUsage.
 * Use `create(FeatureUsageSchema)` to create a new message.
 */
export const FeatureUsageSchema: GenMessage<FeatureUsage> = /*@__PURE__*/
  messageDesc(file_v1_feature_usage, 0);

/**
 * @generated from message v1.RecordFeatureUsageRequest
 */
export type RecordFeatureUsageRequest = Message<"v1.RecordFeatureUsageRequest"> & {
  /**
   * At most 100 entries.
   *
   * @generated from field: repeated v1.FeatureUsage usages = 1;
   */
  usages: FeatureUsage[];
};

/**
 * Describes the message v1.RecordFeatureUsageRequest.
 * Use `create(RecordFeatureUsageRequestSchema)` to create a new message.
 */
export const RecordFeatureUsageRequestSchema: GenMessage<RecordFeatureUsageRequest> = /*@__PURE__*/
  messageDesc(file_v1_feature_usage, 1);

/**
 * @generated from message v1.RecordFeatureUsageResponse
 */
export type RecordFeatureUsageResponse = Message<"v1.RecordFeatureUsageResponse"> & {
  /**
   * Number of entries saved; invalid entries are not counted.
   *
   * @generated from field: int32 accepted = 1;
   */
  accepted: number;
};

/**
 * Describes the message v1.RecordFeatureUsageResponse.
 * Use `create(RecordFeatureUsageResponseSchema)` to create a new message.
 */
export const RecordFeatureUsageResponseSchema: GenMessage<RecordFeatureUsageResponse> = /*@__PURE__*/
  messageDesc(file_v1_feature_usage, 2);

/**
 * FeatureUsageService records how signed-in users use beta features.
 *
 * @generated from service v1.FeatureUsageService
 */
export const FeatureUsageService: GenService<{
  /**
   * Adds a batch of usage counts for the calling user. Invalid entries are
   * skipped; an admin caller is ignored.
   *
   * @generated from rpc v1.FeatureUsageService.RecordFeatureUsage
   */
  recordFeatureUsage: {
    methodKind: "unary";
    input: typeof RecordFeatureUsageRequestSchema;
    output: typeof RecordFeatureUsageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_feature_usage, 0);

